// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.youtube-poster {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  background: #232927;
  overflow: hidden;
}
.youtube-poster > img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.youtube-play {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  margin: auto;
  width: 60px;
  height: 44px;
  border-radius: 8px;
  background: #b9473df0;
  color: #fff;
}
.youtube-label {
  position: absolute;
  bottom: 12px;
  left: 12px;
  color: #fff;
  background: #1c2423d9;
  padding: 2px 7px;
  font-size: 11px;
  border-radius: 3px;
}
.memory-video-link {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  flex-shrink: 0;
}
.youtube-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #232927;
}
.youtube-frame > button,
.youtube-frame > iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
}
.youtube-external {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  margin-top: 10px;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/YoutubeVideo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".youtube-poster {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: #232927;\n  overflow: hidden;\n}\n.youtube-poster > img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.youtube-play {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  margin: auto;\n  width: 60px;\n  height: 44px;\n  border-radius: 8px;\n  background: #b9473df0;\n  color: #fff;\n}\n.youtube-label {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  color: #fff;\n  background: #1c2423d9;\n  padding: 2px 7px;\n  font-size: 11px;\n  border-radius: 3px;\n}\n.memory-video-link {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  flex-shrink: 0;\n}\n.youtube-frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #232927;\n}\n.youtube-frame > button,\n.youtube-frame > iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n.youtube-external {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  margin-top: 10px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
